import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tabs, Tab } from "react-materialize";
import { useNavigate } from "react-router-dom";
import { onNotificationClick } from "../helpers/helper";
import { seenNotification } from "../redux/action/organization";
import {
  getNotifications,
  handleNotificationPress,
  seenNotifications,
} from "../redux/action/notifications";
import { ClipLoader } from "react-spinners";
import { subtract } from "date-and-time";
import Skeleton from "react-loading-skeleton";
import NotificationsLoading from "../layout/NotificationsLoading";

function Notification() {
  const { notifications, loading } = useSelector(
    (state) => state.notifications
  );
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { profile } = useSelector((state) => state.notifications);

  const groupedNotifications = notifications.reduce((groups, notification) => {
    const date = new Date(notification.timestamp).toLocaleDateString();
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(notification);
    return groups;
  }, {});

  function getRelativeDate(dateString) {
    const notificationDate = new Date(dateString);
    const today = new Date();
    // Remove time part for accurate day comparison
    notificationDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    const diff = subtract(today, notificationDate).toDays();

    if (diff === 0) return "Today";
    if (diff === 1) return "Yesterday";
    if (diff <= 3) return `${diff} days ago`;
    return notificationDate.toLocaleDateString();
  }

  useEffect(() => {
    dispatch(getNotifications());
  }, [dispatch]);

  if (loading) {
    return <NotificationsLoading />;
  }

  if (notifications.length === 0) {
    return (
      <div className="flex align-center justify-center  mt-5  column  ">
        <span
          className="material-symbols-outlined grey-text"
          style={{ fontSize: "5rem" }}
        >
          notifications
        </span>
        <p className="grey-text  mt-2 ph-2  ">No new notifications.</p>
      </div>
    );
  }

  return (
    <div className="dashboard-content ">
      <div className="flex justify-center align-center  space-between mb-1">
        <div>
          <h4>Notifications</h4>

          <p>
            You have{" "}
            <span className="cercle-purple-text bold">{profile?.count}</span>{" "}
            new notifications
          </p>
        </div>

        <button
          className="btn btn-outline"
          onClick={() => {
            dispatch(seenNotifications());
          }}
        >
          Mark all as read
        </button>
      </div>

      <div className="">
        {Object.entries(groupedNotifications).map(([date, notifications]) => (
          <div key={date}>
            <h5 className="notification-date">{getRelativeDate(date)}</h5>
            {notifications.map((notf, i) => (
              <div
                className={` flex  border notification-item ${
                  notf.read ? "" : " notifcation-unseen-background"
                }`}
                key={i}
                onClick={() => {
                  handleNotificationPress(notf, navigate, dispatch);
                }}
              >
                <div style={{ flex: 2 }}>
                  <div
                    className="purple circle flex align-center justify-center purple lighten-5 "
                    style={{ width: "43px", height: "43px" }}
                  >
                    <span className="material-symbols-outlined cercle-purple-text icon-bg">
                      local_shipping
                    </span>
                  </div>
                </div>
                &nbsp;
                <div style={{ flex: 8 }}>
                  <p className="semibold-notification">{notf.title}</p>
                  <p className="notification-description">{notf.body}</p>
                </div>
                <div
                  style={{ flex: 1, alignItems: "flex-start" }}
                  className="flex justify-end"
                >
                  {!notf.read && <div className="unread-point"></div>}
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Notification;
